namespace RedBullMOBILE360.CVM {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CVM.CvmCampaignDialog')
    export class CvmCampaignDialog extends Serenity.EntityDialog<CvmCampaignRow, any> {
        protected getFormKey() { return CvmCampaignForm.formKey; }
        protected getIdProperty() { return CvmCampaignRow.idProperty; }
        protected getLocalTextPrefix() { return CvmCampaignRow.localTextPrefix; }
        protected getNameProperty() { return CvmCampaignRow.nameProperty; }
        protected getService() { return CvmCampaignService.baseUrl; }
        protected getDeletePermission() { return CvmCampaignRow.deletePermission; }
        protected getInsertPermission() { return CvmCampaignRow.insertPermission; }
        protected getUpdatePermission() { return CvmCampaignRow.updatePermission; }

        protected form = new CvmCampaignForm(this.idPrefix);
    }
}